var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAgne(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "72px",
    height: "55px",
    viewBox: "0 0 72 55",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group@3x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(1.221271, 0.685512)",
    stroke: "#979797"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.3254371,14.5329603 C60.0985408,18.8035393 63.7939673,15.708224 58.2338862,22.4657262",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8340951,22.8210097 C4.35540473,49.8133079 27.7196052,8.78571393 37.8216578,1.81267155 C38.9481826,1.03507653 42.3200111,-0.808832387 41.6774678,0.399824037 C37.4892078,8.27815235 19.4966082,27.8082405 26.7581502,22.6236875 L25.4685643,26.8446213 C30.2730686,23.4143297 33.3989643,10.9892372 38.1546713,14.4868667 C49.9883974,23.190092 -39.8455416,77.97946 59.4820396,0.875261727 C62.2480148,-1.27185896 54.3007867,7.43170462 52.1495267,10.1944619 C47.5250677,16.1334272 45.0252267,19.5067109 39.6752433,24.8014822 C37.2462176,27.2054402 34.463321,30.2603144 34.5738694,26.8446213 C34.7850267,20.3203392 43.1852009,21.0186398 39.6752433,15.5149101 L40.8980193,10.1944619 C35.4537916,9.26274907 28.6129757,12.2010368 24.4741848,14.5329603 C14.185101,20.3301504 7.34964526,23.1496781 1.53561109,33.2397243 C-0.886561765,37.4433178 -0.0997209892,45.3773296 1.53561109,49.2233387 C2.35888605,51.1595344 3.2400352,53.2349336 5.59961931,52.7891214 C6.54547094,52.6104152 6.53036794,51.8444958 8.31707199,50.9515909 C11.8479772,49.187022 34.003712,22.337334 42.6884203,15.5149101 C45.7405884,13.1172262 32.4053831,29.3015827 35.4537916,26.8446213 C40.9350483,22.4268289 48.515258,16.0437903 50.5,14.5329603",
    id: "Path-2"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgne);
export default __webpack_public_path__ + "static/media/agne.720c266862632c1467339bf461c0d656.svg";
export { ForwardRef as ReactComponent };